import { TYPES } from './actions';
import { merge } from '../../../../utils/state';

const initialState = {
  subOrgs: {
    isLoading: false,
    error: null,
    data: {},
    pagination: {
      hasNextPage: true,
      pageNumber: 0,
      pageSize: 20,
    },
  },
  jobGroups: {
    isLoading: false,
    error: null,
    data: {},
    pagination: {
      hasNextPage: true,
      pageNumber: 0,
      pageSize: 20,
    },
  },
  jobs: {
    isLoading: false,
    error: null,
    data: {},
    pagination: {
      hasNextPage: true,
      pageNumber: 0,
      pageSize: 20,
    },
  },
  tableJobs: {
    isLoading: false,
    error: null,
    data: {},
    pagination: {
      pageSize: 15,
      pageNumber: 1,
      hasMore: false,
      totalElements: 0,
      totalPages: 0,
    },
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TYPES.LOAD_SUB_ORGS_REQUEST:
      return merge(state, {
        subOrgs: merge(state.subOrgs, { isLoading: true }),
      });
    case TYPES.LOAD_SUB_ORGS_SUCCESS:
      return merge(state, {
        subOrgs: merge(state.subOrgs, {
          isLoading: false,
          data: action.payload.overwrite ? action.payload.data : merge(state.subOrgs.data, action.payload.data),
          pagination: merge(state.subOrgs.pagination, action.payload.pagination),
        }),
      });
    case TYPES.LOAD_SUB_ORGS_ERROR:
      return merge(state, {
        subOrgs: merge(state.subOrgs, { isLoading: false, error: action.payload }),
      });
    case TYPES.LOAD_JOB_GROUPS_REQUEST:
      return merge(state, {
        jobGroups: merge(state.jobGroups, { isLoading: true }),
      });
    case TYPES.LOAD_JOB_GROUPS_SUCCESS:
      return merge(state, {
        jobGroups: merge(state.jobGroups, {
          isLoading: false,
          data: action.payload.overwrite ? action.payload.data : merge(state.jobGroups.data, action.payload.data),
          pagination: merge(state.jobGroups.pagination, action.payload.pagination),
        }),
      });
    case TYPES.LOAD_JOB_GROUPS_ERROR:
      return merge(state, {
        jobGroups: merge(state.jobGroups, { isLoading: false, error: action.payload }),
      });
    case TYPES.LOAD_JOBS_REQUEST:
      return merge(state, {
        jobs: merge(state.jobs, { isLoading: true }),
      });
    case TYPES.LOAD_JOBS_SUCCESS:
      return merge(state, {
        jobs: merge(state.jobs, {
          isLoading: false,
          data: action.payload.overwrite ? action.payload.data : merge(state.jobs.data, action.payload.data),
          pagination: merge(state.jobs.pagination, action.payload.pagination),
        }),
      });
    case TYPES.LOAD_JOBS_ERROR:
      return merge(state, {
        jobs: merge(state.jobs, { isLoading: false, error: action.payload }),
      });
    case TYPES.LOAD_TABLE_JOBS_REQUEST:
      if (action.payload?.page === 1) {
        return merge(state, {
          tableJobs: merge(state.tableJobs, {
            isLoading: true,
          }),
        });
      }
      return merge(state, {
        tableJobs: merge(state.tableJobs, { isLoading: true }),
      });
    case TYPES.LOAD_TABLE_JOBS_SUCCESS:
      return merge(state, {
        tableJobs: merge(state.tableJobs, {
          isLoading: false,
          data: action.payload.content,
          pagination: merge(state.tableJobs.pagination, {
            pageNumber: action.payload.pagination.page_current,
            hasMore: action.payload.pagination.page_total > action.payload.pagination.page_current,
            totalElements: action.payload.pagination.element_total,
            totalPages: action.payload.pagination.page_total,
          }),
        }),
      });
    case TYPES.LOAD_TABLE_JOBS_ERROR:
      return merge(state, {
        tableJobs: merge(state.tableJobs, {
          isLoading: false,
          error: action.payload,
          pagination: merge(state.tableJobs.pagination, {
            totalElements: 0,
          }),
        }),
      });
    case TYPES.CLEAR_TABLE_JOBS_STATE:
      return initialState.tableJobs;
    default:
      return state;
  }
}
